import { usePersonsFetchingContext } from 'entities/person/persons-layout';

import { ConnectedReservesTable } from '../../../widgets/session/reserve-sessions-table/ui/connected-table';

export function PersonsReservesPage() {
  const { handleSetFetchingTab } = usePersonsFetchingContext();

  return <ConnectedReservesTable handleSetFetchingTab={handleSetFetchingTab} />;
}
